import { render } from "./DBox.vue?vue&type=template&id=f0c86730&scoped=true"
import script from "./DBox.vue?vue&type=script&lang=ts"
export * from "./DBox.vue?vue&type=script&lang=ts"

import "./DBox.vue?vue&type=style&index=0&id=f0c86730&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0c86730"

export default script